import React from 'react';

import Hero from 'components/hero';

const EmployerCostEffective = () => {
  return (
    <Hero className="bg-secondary text-center" layout="vertical">
      <h2 style={{ color: 'white' }}>
        MyShifts is the most Cost Effective Recruitment Tool Ever. For the
        Health and Social Care Sector.
      </h2>
      <p style={{ color: 'white' }}>
        MyShifts is simply a platform to enable you (as the employer), to
        connect directly with available and suitable workers. This means you
        don’t pay Myshifts any commission, there are no hidden fees and above
        all it is a one off &apos;connection&apos; fee.
      </p>
    </Hero>
  );
};

export default EmployerCostEffective;
